"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dashboardFarmList = _interopRequireDefault(require("../dashboard-farm-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DashboardOpenMembershipFeeList = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardOpenMembershipFeeList, _React$Component);

  function DashboardOpenMembershipFeeList(props) {
    _classCallCheck(this, DashboardOpenMembershipFeeList);

    return _possibleConstructorReturn(this, (DashboardOpenMembershipFeeList.__proto__ || Object.getPrototypeOf(DashboardOpenMembershipFeeList)).call(this, props));
  }

  _createClass(DashboardOpenMembershipFeeList, [{
    key: "render",
    value: function render() {
      var i18n = this.props.i18n;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-dashboard-open-membership-farm-list comp-dashboard-farm-list'
      }, /*#__PURE__*/_react.default.createElement(_dashboardFarmList.default, _extends({
        loadFarmsUrl: "/api/".concat(i18n.language, "/administration/farm/open-membership-fees")
      }, this.props)));
    }
  }]);

  return DashboardOpenMembershipFeeList;
}(_react.default.Component);

DashboardOpenMembershipFeeList.propTypes = {
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  t: _propTypes.default.func.isRequired
};
var _default = DashboardOpenMembershipFeeList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard-open-membership-fee-list/index.js
// module id = 172
// module chunks = 0